import { useEffect, useState, useMemo } from 'react';

import {
  getTouchpoint,
  subscribeTouchpoint,
} from '@/utils/environment/touchpointResolver';
import { PORTFOLIO_APP_TOUCH_POINT } from '@/utils/environment/surface';

/**
 * React subscription to the singleton touchpoint resolver. Multiple
 * consumers share one polling loop (see touchpointResolver.ts).
 */
const useTouchpoint = () => {
  const [touchpoint, setTouchpoint] = useState<string | null>(getTouchpoint);

  useEffect(() => subscribeTouchpoint(setTouchpoint), []);

  return useMemo(() => {
    const isPortfolioApp = touchpoint === PORTFOLIO_APP_TOUCH_POINT;

    return {
      touchpoint,
      isPortfolioApp,
    };
  }, [touchpoint]);
};

export default useTouchpoint;
